import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import companyLogo from '../assets/icon_logo.webp';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavigation = (sectionId) => {
    if (location.pathname === '/') {
      // If on homepage, scroll to section
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // If on other pages, navigate to homepage then scroll
      window.location.href = `/#${sectionId}`;
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <Link to="/">
              <img src={companyLogo} alt="Company Logo" className="logo-image" />
              <h2>Ludic Labs Technology Limited</h2>
            </Link>
          </div>
          
          <nav className={`nav ${isMobileMenuOpen ? 'nav-open' : ''}`}>
            <ul>
              <li>
                <button onClick={() => handleNavigation('home')}>Home</button>
              </li>
              <li>
                <button onClick={() => handleNavigation('about')}>About</button>
              </li>
              <li>
                <button onClick={() => handleNavigation('services')}>Services</button>
              </li>
              <li>
                <button onClick={() => handleNavigation('games')}>Games</button>
              </li>
              <li>
                <button onClick={() => handleNavigation('contact')}>Contact</button>
              </li>
              <li>
                <Link 
                  to="/privacy-policy" 
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={location.pathname === '/privacy-policy' ? 'active' : ''}
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </nav>

          <button 
            className="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
